<template>
  <div
    class="tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-3 tw-rounded-md tw-border-2 tw-p-3 tw-border-branding-blue-500 tw-bg-branding-blue-100"
    role="alert"
    :data-test-id="`msp-branding-logo-info-banner`"
  >
    <div
      class="tw-bg-branding-blue-200 tw-p-1 tw-rounded-full tw-text-branding-blue-500"
    >
      <cb-icon-information
        :data-test-id="`msp-branding-logo-info-banner-info-icon`"
      />
    </div>
    <div class="tw-flex-grow tw-whitespace-normal tw-break-words">
      <div
        class="tw-text-lg tw-font-semibold"
        :data-test-id="`msp-branding-logo-info-banner-title`"
      >
        {{ t("logo-info-title") }}
      </div>
      <div :data-test-id="`msp-branding-logo-info-banner-message`">
        {{ t("logo-info-banner") }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
